import * as React from 'react';
import styled from 'styled-components';
import { ListPluginBaseProps } from '../types';
import { SharedListStyle } from '../../../../BlogEditor/plugins/BulletPoint/element/ListStyle';

const Main = styled.ul`
  ${SharedListStyle}
`;



interface UnorderedListElementProps extends ListPluginBaseProps {}

export const UnorderedListElement = (props: UnorderedListElementProps) => {
  const { children, attributes } = props;

  return (
    <Main {...attributes} className="unordered-list-element">
      {children}
    </Main>
  );
};
